<template>
  <button
    class="btn"
    :class="{'disabled': disabled}"
    @click="$emit('click')"
  >
    {{ name }}
  </button>
</template>

<script>
  export default {
    name: 'Btn',
    components: {},
    props: {
      name: {
        type: String,
        default: 'Save',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
      };
    },
    apollo: {},
    computed: {
    },
    watch: {},
    mounted() {},
    methods: {},
  };
</script>


<style lang="stylus" scoped>
  .btn
    cursor: pointer
    height: 50px
    min-width: 100px
    text-align: center
    &.disabled
      opacity: 0.5
      pointer-events: none
</style>
